import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import Button from '../components/Button';
import { SparklesIcon, HeartIcon, CrownIcon, RocketIcon, ArrowRightIcon } from 'lucide-react';
const History = () => {
  const {
    scrollYProgress
  } = useScroll();
  const milestones = [{
    year: '2017',
    title: 'Fundación de Grupo Reflex',
    description: 'Nacemos con la convicción de que toda marca tiene una historia que merece ser contada con propósito. Desde nuestros primeros proyectos, apostamos por unir estrategia, arte y tecnología para crear comunicación que no solo se vea, sino que se sienta.',
    image: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80'
  }, {
    year: '2019',
    title: 'Expansión internacional y alianzas globales',
    description: "Extendemos nuestro alcance más allá de Guatemala, estableciendo alianzas estratégicas con marcas como Hyundai, Mazda, Peugeot y Syngenta, además de colaborar con iniciativas humanitarias como Charlene's Project en Cuba y Uganda.",
    image: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80'
  }, {
    year: '2021',
    title: 'Evolución hacia Agencia de Creación de Contenido',
    description: 'Consolidamos nuestro Estudio y abrimos nuevas divisiones de Diseño Gráfico, Manejo de Redes Sociales e Impresiones de Gran Formato. Nos convertimos en una agencia integral de comunicación visual capaz de construir marcas y conectar audiencias.',
    image: 'https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80'
  }, {
    year: '2023',
    title: 'Expansión al sector inmobiliario',
    description: 'El sector inmobiliario se convierte en nuestro bastión más importante. Ejecutamos producciones audiovisuales, campañas de lanzamiento y desarrollo de identidad para proyectos urbanísticos, transformando cada obra en una historia visual que inspira.',
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80'
  }, {
    year: '2025',
    title: 'Integración estratégica de Inteligencia Artificial',
    description: 'Iniciamos una nueva era con ORION, nuestra IA desarrollada internamente. Representa la unión entre el pensamiento humano y la inteligencia algorítmica, consolidando a Grupo Reflex como pionero en la convergencia entre arte, tecnología y propósito.',
    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80'
  }];
  const values = [{
    title: 'No es como se ve... ¡Es como se siente!',
    description: 'Creamos experiencias que trascienden lo visual y conectan emocionalmente con la audiencia.',
    icon: <HeartIcon className="h-12 w-12" data-id="element-232" />,
    gradient: 'from-pink-600/20 to-red-600/20',
    image: 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80'
  }, {
    title: '¡La historia es Reina!',
    description: 'Cada proyecto cuenta una historia única que resuena con tu audiencia y deja huella.',
    icon: <CrownIcon className="h-12 w-12" data-id="element-233" />,
    gradient: 'from-purple-600/20 to-pink-600/20',
    image: 'https://images.unsplash.com/photo-1485846234645-a62644f84728?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80'
  }, {
    title: '¿Nuestro mejor trabajo? …¡El siguiente!',
    description: 'Siempre buscamos superar nuestros límites y establecer nuevos estándares de excelencia.',
    icon: <RocketIcon className="h-12 w-12" data-id="element-234" />,
    gradient: 'from-blue-600/20 to-purple-600/20',
    image: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80'
  }];
  return <>
      {/* Hero Section - Full Screen */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden" data-id="element-235">
        <div className="absolute inset-0" data-id="element-236">
          <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" alt="Historia" className="w-full h-full object-cover" data-id="element-237" />
          <div className="absolute inset-0 bg-gradient-to-b from-gray-900/90 via-purple-900/85 to-gray-900/90" data-id="element-238"></div>
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1
      }} className="container mx-auto px-4 md:px-6 relative z-10 text-center" data-id="element-239">
          <div className="flex items-center justify-center mb-6" data-id="element-240">
            <SparklesIcon className="h-12 w-12 text-purple-400 mr-4" data-id="element-241" />
            <h1 className="text-5xl md:text-7xl font-bold text-white" data-id="element-242">
              Nuestra Historia
            </h1>
          </div>
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto" data-id="element-243">
            Un viaje de{' '}
            <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent font-semibold" data-id="element-244">
              pasión, creatividad e innovación
            </span>
          </p>
        </motion.div>
        {/* Scroll Indicator */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1
      }} className="absolute bottom-10 left-1/2 -translate-x-1/2" data-id="element-245">
          <motion.div animate={{
          y: [0, 10, 0]
        }} transition={{
          duration: 2,
          repeat: Infinity
        }} className="text-white" data-id="element-246">
            <ArrowRightIcon className="h-8 w-8 rotate-90" data-id="element-247" />
          </motion.div>
        </motion.div>
      </section>
      {/* Story Section - Full Width Image */}
      <section className="relative py-32" data-id="element-248">
        <div className="absolute inset-0" data-id="element-249">
          <img src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" alt="Team" className="w-full h-full object-cover" data-id="element-250" />
          <div className="absolute inset-0 bg-gradient-to-r from-gray-900/95 via-purple-900/80 to-gray-900/95" data-id="element-251"></div>
        </div>
        <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-252">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 1
        }} viewport={{
          once: true
        }} className="max-w-3xl" data-id="element-253">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-8" data-id="element-254">
              De la idea a la{' '}
              <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent" data-id="element-255">
                realidad
              </span>
            </h2>
            <div className="space-y-6 text-lg text-gray-300" data-id="element-256">
              <p data-id="element-257">
                Grupo Reflex comenzó como un sueño compartido por un grupo de
                creativos y tecnólogos que creían en el poder de la innovación
                para transformar industrias y experiencias.
              </p>
              <p data-id="element-258">
                A lo largo de los años, hemos crecido y evolucionado, pero
                nuestra misión sigue siendo la misma: crear soluciones
                impactantes que combinen creatividad, tecnología y estrategia.
              </p>
              <p data-id="element-259">
                Hoy, nos enorgullece ser un referente en la industria,
                trabajando con clientes de diversos sectores que confían en
                nuestra visión y capacidad para convertir sus ideas en
                realidades tangibles.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
      {/* Timeline Section with Curves */}
      <section className="py-32 bg-gray-900 relative overflow-hidden" data-id="element-260">
        <div className="absolute inset-0 opacity-10" data-id="element-261">
          <div className="absolute top-0 right-0 w-96 h-96 bg-purple-500 rounded-full blur-3xl" data-id="element-262"></div>
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-pink-500 rounded-full blur-3xl" data-id="element-263"></div>
        </div>
        <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-264">
          <motion.div initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} viewport={{
          once: true
        }} className="text-center mb-20" data-id="element-265">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white" data-id="element-266">
              Nuestra{' '}
              <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent" data-id="element-267">
                trayectoria
              </span>
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-268">
              Un camino de evolución constante y crecimiento
            </p>
          </motion.div>
          {/* Curved Timeline */}
          <div className="relative max-w-6xl mx-auto" data-id="element-269">
            {/* SVG Curved Path */}
            <svg className="absolute inset-0 w-full h-full pointer-events-none" style={{
            height: `${milestones.length * 400}px`
          }} data-id="element-270">
              <motion.path d={`M 300 0 Q 100 200, 300 400 T 300 800 T 300 1200 T 300 1600 T 300 2000`} stroke="url(#gradient)" strokeWidth="3" fill="none" initial={{
              pathLength: 0
            }} whileInView={{
              pathLength: 1
            }} transition={{
              duration: 2,
              ease: 'easeInOut'
            }} viewport={{
              once: true
            }} data-id="element-271" />
              <defs data-id="element-272">
                <linearGradient id="gradient" x1="0%" y1="0%" x2="0%" y2="100%" data-id="element-273">
                  <stop offset="0%" stopColor="#a855f7" data-id="element-274" />
                  <stop offset="50%" stopColor="#ec4899" data-id="element-275" />
                  <stop offset="100%" stopColor="#a855f7" data-id="element-276" />
                </linearGradient>
              </defs>
            </svg>
            {/* Timeline Items */}
            <div className="relative" style={{
            height: `${milestones.length * 400}px`
          }} data-id="element-277">
              {milestones.map((milestone, index) => {
              const isLeft = index % 2 === 0;
              const yPosition = index * 400;
              return <motion.div key={index} initial={{
                opacity: 0,
                x: isLeft ? -100 : 100
              }} whileInView={{
                opacity: 1,
                x: 0
              }} transition={{
                duration: 0.8,
                delay: index * 0.2
              }} viewport={{
                once: true
              }} className="absolute" style={{
                top: `${yPosition}px`,
                left: isLeft ? '0' : 'auto',
                right: isLeft ? 'auto' : '0',
                width: '45%'
              }} data-id="element-278">
                    <div className="group relative h-80 rounded-2xl overflow-hidden cursor-pointer" data-id="element-279">
                      <div className="absolute inset-0" data-id="element-280">
                        <img src={milestone.image} alt={milestone.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-281" />
                        <div className="absolute inset-0 bg-gradient-to-br from-purple-600/30 to-pink-600/30 group-hover:opacity-90 transition-opacity duration-500" data-id="element-282"></div>
                        <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/70 to-transparent" data-id="element-283"></div>
                      </div>
                      <div className="relative h-full p-8 flex flex-col justify-end" data-id="element-284">
                        <div className="bg-gradient-to-r from-purple-600 to-pink-600 text-white text-2xl font-bold py-2 px-6 rounded-lg inline-block mb-4 w-fit" data-id="element-285">
                          {milestone.year}
                        </div>
                        <h3 className="text-3xl font-bold text-white mb-3" data-id="element-286">
                          {milestone.title}
                        </h3>
                        <p className="text-gray-300 text-lg" data-id="element-287">
                          {milestone.description}
                        </p>
                      </div>
                      {/* Dot on the curve */}
                      <motion.div initial={{
                    scale: 0
                  }} whileInView={{
                    scale: 1
                  }} transition={{
                    duration: 0.5,
                    delay: index * 0.2
                  }} viewport={{
                    once: true
                  }} className="absolute top-1/2 -translate-y-1/2 w-6 h-6 rounded-full bg-gradient-to-r from-purple-500 to-pink-500 border-4 border-gray-900" style={{
                    [isLeft ? 'right' : 'left']: '-3rem'
                  }} data-id="element-288" />
                    </div>
                  </motion.div>;
            })}
            </div>
          </div>
        </div>
      </section>
      {/* Values Section */}
      <section className="py-32 bg-gray-900" data-id="element-289">
        <div className="container mx-auto px-4 md:px-6" data-id="element-290">
          <motion.div initial={{
          opacity: 0,
          y: 50
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} viewport={{
          once: true
        }} className="text-center mb-20" data-id="element-291">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white" data-id="element-292">
              Nuestros{' '}
              <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent" data-id="element-293">
                valores
              </span>
            </h2>
            <p className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-294">
              Los principios que guían cada proyecto que emprendemos
            </p>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-295">
            {values.map((value, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 50
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.8,
            delay: index * 0.1
          }} viewport={{
            once: true
          }} className="group relative h-[500px] rounded-2xl overflow-hidden cursor-pointer" data-id="element-296">
                <div className="absolute inset-0" data-id="element-297">
                  <img src={value.image} alt={value.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-298" />
                  <div className={`absolute inset-0 bg-gradient-to-br ${value.gradient} group-hover:opacity-90 transition-opacity duration-500`} data-id="element-299"></div>
                  <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/70 to-transparent" data-id="element-300"></div>
                </div>
                <div className="relative h-full p-8 flex flex-col justify-end" data-id="element-301">
                  <div className="text-purple-400 mb-4 transform group-hover:scale-110 transition-transform duration-500" data-id="element-302">
                    {value.icon}
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-3" data-id="element-303">
                    {value.title}
                  </h3>
                  <p className="text-gray-300" data-id="element-304">{value.description}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* CTA Section - Full Screen */}
      <section className="relative h-screen flex items-center justify-center" data-id="element-305">
        <div className="absolute inset-0" data-id="element-306">
          <img src="https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80" alt="Join us" className="w-full h-full object-cover" data-id="element-307" />
          <div className="absolute inset-0 bg-gradient-to-b from-gray-900/80 via-purple-900/90 to-gray-900/80" data-id="element-308"></div>
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 50
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1
      }} viewport={{
        once: true
      }} className="container mx-auto px-4 md:px-6 text-center relative z-10" data-id="element-309">
          <h2 className="text-4xl md:text-6xl font-bold mb-6 text-white" data-id="element-310">
            Sé parte de
            <br data-id="element-311" />
            <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent" data-id="element-312">
              nuestra historia
            </span>
          </h2>
          <p className="text-xl md:text-2xl text-gray-300 mb-12 max-w-3xl mx-auto" data-id="element-313">
            Si te apasiona la creatividad y la innovación, queremos conocerte
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-314">
            <Button href="/contacto" variant="primary" size="lg" className="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700 text-lg px-8 py-4" data-id="element-315">
              Únete al equipo
              <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-316" />
            </Button>
            <Button href="/proyectos" variant="outline" size="lg" className="border-2 border-white text-white hover:bg-white hover:text-gray-900 text-lg px-8 py-4" data-id="element-317">
              Ver proyectos
            </Button>
          </div>
        </motion.div>
      </section>
    </>;
};
export default History;